import { render, staticRenderFns } from "./CarrierFormContact.vue?vue&type=template&id=58285487&scoped=true&"
import script from "./CarrierFormContact.vue?vue&type=script&lang=ts&"
export * from "./CarrierFormContact.vue?vue&type=script&lang=ts&"
import style0 from "./CarrierFormContact.vue?vue&type=style&index=0&id=58285487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58285487",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
